import { isEmptyString } from '../../util/object';
import { isNumber } from '../../util/numbers';

export class RasteredImageBitmapInterface {
  _mediaIdentifier = null;
  _frameNumber = null;
  _imageBitmap = null;
  _mediaURL = null;

  /** @property {String} */
  static identifier = 'RasteredImageBitmap';

  constructor(mediaIdentifier, frameNumber, imageBitmap, mediaURL) {
    if (
      isEmptyString(mediaIdentifier) ||
      !isNumber(frameNumber) ||
      !(imageBitmap instanceof ImageBitmap)
    ) {
      throw new Error(
        `${RasteredImageBitmapInterface.name} was not initialized with correct params`,
      );
    }
    this._mediaIdentifier = mediaIdentifier;
    this._frameNumber = frameNumber;
    this._imageBitmap = imageBitmap;
  }

  /**
   * @typedef {Object} RasteredImageBitmapTransferrable
   * @param  {RasteredImageBitmapInterface.identifier} type
   * @param  {type} mediaIdentifier
   * @param  {type} frameNumber
   * @param  {type} imageBitmap
   */

  /**
   * @function createTransferrable
   * @param  {String} mediaIdentifier
   * @param  {Number} frameNumber
   * @param  {ImageBitmap} imageBitmap
   * @return {RasteredImageBitmapTransferrable}
   */
  static createTransferrable(mediaIdentifier, frameNumber, imageBitmap) {
    return {
      type: RasteredImageBitmapInterface.identifier,
      mediaIdentifier,
      frameNumber,
      imageBitmap,
    };
  }

  /**
   * @function fromTransferrable
   * @param  {RasteredImageBitmapTransferrable} rasteredImageBitmapTransferrable
   * @return {RasteredImageBitmapInterface}
   */
  static fromTransferrable(rasteredImageBitmapTransferrable) {
    return new RasteredImageBitmapInterface(
      rasteredImageBitmapTransferrable.mediaIdentifier,
      rasteredImageBitmapTransferrable.frameNumber,
      rasteredImageBitmapTransferrable.imageBitmap,
    );
  }

  get mediaIdentifier() {
    return this._mediaIdentifier;
  }

  get frameNumber() {
    return this._frameNumber;
  }

  get imageBitmap() {
    return this._imageBitmap;
  }
}
